/**
 * Deterministic URLs for website/style preview screenshots stored in S3.
 *
 * Two screenshot families (landing demo previews and create-flow template
 * previews) are generated locally (DEBUG-only admin actions) and uploaded by the
 * backend to a fixed PRODUCTION previews bucket under `public/previews/...`.
 * They are served directly from S3 — they are NOT committed to / shipped from the
 * frontend `public/` folder anymore.
 *
 * The base URL points at that bucket and can be overridden per environment with
 * `REACT_APP_PREVIEWS_BASE_URL` (e.g. in Amplify or a local `.env`). It defaults
 * to the production media bucket so it works out of the box.
 *
 * Keys mirror the backend `website/utils/preview_uploads.py` helpers:
 *   public/previews/demo-public-sites/<domain>/preview.png
 *   public/previews/demo-public-sites/<domain>/preview_mobile.png
 *   public/previews/template-previews/<domain>/preview.png
 */

const DEFAULT_PREVIEWS_BASE_URL = "https://myvitae-media-prd.s3.amazonaws.com";

const PREVIEWS_BASE_URL = String(
  process.env.REACT_APP_PREVIEWS_BASE_URL || DEFAULT_PREVIEWS_BASE_URL
).replace(/\/+$/, "");

const PREVIEWS_ROOT = `${PREVIEWS_BASE_URL}/public/previews`;

/** Desktop landing-demo preview screenshot URL for a demo `domain`. */
export const demoPreviewUrl = (domain) =>
  `${PREVIEWS_ROOT}/demo-public-sites/${domain}/preview.png`;

/** Mobile landing-demo preview screenshot URL for a demo `domain`. */
export const demoPreviewMobileUrl = (domain) =>
  `${PREVIEWS_ROOT}/demo-public-sites/${domain}/preview_mobile.png`;

/** Template/style preview screenshot URL for a preview `domain`. */
export const templatePreviewUrl = (domain) =>
  `${PREVIEWS_ROOT}/template-previews/${domain}/preview.png`;

export { PREVIEWS_BASE_URL };
